<ui-alert *visible="hasError; transition 'slide'" [type]="alertType">
  <div ui-body>
    <strong *ngIf="status >= 400" i18n>
      אופס..., אירעה שגיאה, בדוק את הנתונים ונסה שנית
    </strong>

    <strong *ngIf="status < 400" i18n>
      אירעה שגיאה במערכת
    </strong>
    <br />
    <span i18n *ngIf="status >= 500" class="mt-10">
      במקרה הצורך פנה למערכות מידע לצורך טיפול בתקלה
    </span>
    <div class="ui-error-actions">
      <ui-phone-link>02-6751152</ui-phone-link>

      <a
        mat-stroked-button
        class="ui-error-support"
        href="https://forms-jct.binaa.co.il/it-support-ticket/"
        target="_blank"
        rel="noopener noreferrer">
        <mat-icon>support_agent</mat-icon>&nbsp;

        <span i18n>שלח בקשה לתמיכה</span>
      </a>
    </div>
  </div>
</ui-alert>